/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Art_Value_SourceInputs */

const en_svc_integration_art_value_source = /** @type {(inputs: Svc_Integration_Art_Value_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice-2048.pdf`)
};

const lv_svc_integration_art_value_source = /** @type {(inputs: Svc_Integration_Art_Value_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rēķins-2048.pdf`)
};

/**
* | output |
* | --- |
* | "Invoice-2048.pdf" |
*
* @param {Svc_Integration_Art_Value_SourceInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_art_value_source = /** @type {((inputs?: Svc_Integration_Art_Value_SourceInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Art_Value_SourceInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_art_value_source(inputs)
	return en_svc_integration_art_value_source(inputs)
});